import { render } from "./CustomerReport.vue?vue&type=template&id=55fcdde2&scoped=true"
import script from "./CustomerReport.vue?vue&type=script&lang=js"
export * from "./CustomerReport.vue?vue&type=script&lang=js"

import "./CustomerReport.vue?vue&type=style&index=0&id=55fcdde2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55fcdde2"]])

export default __exports__